var $f8f1e72c8b5447d6$exports = {};
$f8f1e72c8b5447d6$exports = {
  "deselectedItem": function deselectedItem(args) {
    return "".concat(args.item, " nicht ausgew\xE4hlt.");
  },
  "longPressToSelect": "Gedr\xFCckt halten, um Auswahlmodus zu \xF6ffnen.",
  "select": "Ausw\xE4hlen",
  "selectedAll": "Alle Elemente ausgew\xE4hlt.",
  "selectedCount": function selectedCount(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      "=0": "Keine Elemente ausgew\xE4hlt",
      one: function one() {
        return "".concat(formatter.number(args.count), " Element ausgew\xE4hlt");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " Elemente ausgew\xE4hlt");
      }
    }), ".");
  },
  "selectedItem": function selectedItem(args) {
    return "".concat(args.item, " ausgew\xE4hlt.");
  }
};
export { $f8f1e72c8b5447d6$exports as default };